export default __webpack_public_path__ + "app/images/theme-images/light/ic-answering/icon-64-answering@2x.webp";